import validate from "/mnt/data/maitop/robo-nation/code/platforms/web/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}